/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Reason_OtherInputs */

const en_us2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_br2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const es_419_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const pt_pt2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const fr_fr2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_de2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderes`)
};

const it_it2_exercise_sheet_report_reason_other = /** @type {(inputs: Exercise_Sheet_Report_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Exercise_Sheet_Report_Reason_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_reason_other = /** @type {((inputs?: Exercise_Sheet_Report_Reason_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Reason_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_reason_other(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_reason_other(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_reason_other(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_reason_other(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_reason_other(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_reason_other(inputs)
	return en_us2_exercise_sheet_report_reason_other(inputs)
});
export { exercise_sheet_report_reason_other as "exercise-sheet.report_reason_other" }